import { PageType } from '@hotelplan/graphql.types';
import { searchStateUnitRef } from '@hotelplan/libs.search-state-api';
import { Container } from 'components/core/container';
import { GeoTabsKey } from 'components/domain/geo/Geo.types';
import GeoPageLayout from 'components/domain/geo/GeoPageLayout';
import { useGeoTabs } from 'components/domain/geo/hooks';
import { createPageServerFn } from 'config';
import { geoSearchStateUnit } from 'config/geo/geoSearchStateUnit';
import { serverGeoContentUnit } from 'config/geo/serverGeoContentUnit';
import { serverGeoCorrectUrlUnit } from 'config/geo/serverGeoCorrectUrlUnit';
import { GetGeoContentQuery } from 'graphql/geo/GetGeoContent.generated';

interface IGeoPageProps {
  id: string;
  geoContent: GetGeoContentQuery;
}

export default function GeoChildrenPage({
  geoContent,
}: IGeoPageProps): React.ReactElement {
  const { tabItems, getComponentByTab } = useGeoTabs(geoContent.geo);

  return (
    <Container>
      <GeoPageLayout
        tabItems={tabItems}
        tabKey={GeoTabsKey.Children}
        {...geoContent.geo}
      >
        {getComponentByTab(GeoTabsKey.Children)}
      </GeoPageLayout>
    </Container>
  );
}

export const getServerSideProps = createPageServerFn(
  {
    namespaceRequired: ['geo'],
    pageEventType: 'geo.detail',
    pageType: PageType.GeoChildrenOffers,
  },
  [
    geoSearchStateUnit,
    serverGeoCorrectUrlUnit,
    serverGeoContentUnit({ ref: 'geo-children-ref' }).withDep(
      searchStateUnitRef
    ),
  ]
);
